import React from "react";

const TYPE_CONFIG = {
  success: {
    bg: "#08b89d",
    icon: "icon-check-bold",
    defaultTitle: "Successful",
  },
  warning: {
    bg: "#f2be28",
    icon: "icon-warning-bold",
    defaultTitle: "Warning",
  },
  info: { bg: "#253ff6", icon: "icon-info-bold", defaultTitle: "Info" },
  error: { bg: "#ef4056", icon: "icon-close-bold", defaultTitle: "Error" },
};

const CustomToast = ({ type = "success", title, message, onClose }) => {
  const config = TYPE_CONFIG[type] || TYPE_CONFIG.success;

  return (
    <div className="flex gap-[18px] mb-3  rounded-[var(--Radius-radius-m---0-75-rem,12px)] bg-white shadow-[0_2px_6px_rgba(0,0,0,0.25)]  p-[18px] w-[400px] max-w-[90vw] items-center  self-stretch justify-between">
      <div className="flex gap-3 items-center ">
        <div className="w-[30px] h-[30px] flex justify-center items-center ">
          <span
            className={`icon ${config.icon} text-[25px]`}
            style={{ color: config.bg }}
          />
        </div>

        <div className="flex-1 flex flex-col gap-3 justify-center items-start">
          <p className="text-lg font-bold text-[#333333] leading-none">
            {title || config.defaultTitle}
          </p>

          <p className="text-sm text-[#A0A0A0] leading-none">{message}</p>
        </div>
      </div>
      <div className="w-[30px] h-[30px] flex justify-center items-center ">
        <span
          onClick={onClose}
          className="icon icon-close-1 text-[#A0A0A0] text-[16px]"
        />
      </div>
    </div>
  );
};

export default CustomToast;
